import React, { useLayoutEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { languageSuffixMap } from "constant"
import KioskFoodImage from "./KioskFoodImage"
import KioskFoodFooter from "./KioskFoodFooter"
import KioskFoodCardOptions from "./KioskFoodCardOptions"
import KioskFoodDescription from "./KioskFoodDescription"
import classes from "./index.module.scss"

const KioskFood = () => {
  const foodId = useParams()._id

  const i18n = useTranslation()[1]

  const food =
    useSelector(state => state.foods?.[foodId])

  const [quantity, setQuantity] = useState(1)
  const [selectedOption, setSelectedOption] = useState(null)

  const selectInitialOption = () => {
    if (!food) return

    const firstInStockOption =
      food.options.find(option =>
        option.isAvailable
          ?
          option.isOutOfStock
            ?
            false
            :
            option.stockManagement
              ? option.availableQuantity > 0
              : true
          :
          false
      )

    setSelectedOption(firstInStockOption)
  }

  useLayoutEffect(() => {
    selectInitialOption()
  }, [food])

  const loading =
    !food || !selectedOption

  if (loading) return null

  const foodDescription =
    food[`description${languageSuffixMap[i18n.language]}`]

  return (
    <div className={classes["container"]}>
      <div className={classes["top"]}>
        <KioskFoodImage
          food={food}
          selectedOption={selectedOption}
        />

        <KioskFoodDescription
          foodDescription={foodDescription}
        />

        <KioskFoodCardOptions
          food={food}
          setQuantity={setQuantity}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
        />
      </div>

      <div className={classes["bottom"]}>
        {/* <KioskFoodQuantity
          quantity={quantity}
          setQuantity={setQuantity}
          selectedOption={selectedOption}
        /> */}

        <KioskFoodFooter
          food={food}
          quantity={quantity}
          selectedOption={selectedOption}
        />
      </div>
    </div>
  )
}

export default KioskFood